import React, { ReactNode } from 'react';
import clsx from 'clsx';

import { Header } from './header/header';
import styles from './modal-view.scss';

interface ModalViewProps {
  children?: ReactNode;
  className?: string;
  contentClassName?: string;
  headerStyle?: 'fixed' | 'sticky';
  style?: React.CSSProperties;
  headerButtons?: ReactNode;
  title: string | ReactNode;
}

export const ModalView = ({
  children,
  className,
  contentClassName,
  headerStyle = 'sticky',
  headerButtons,
  title,
  style
}: ModalViewProps) => {
  return (
    <div className={clsx(styles.container, { [styles.allowScroll]: headerStyle === 'fixed' }, className)}>
      <Header position={headerStyle} rightContent={headerButtons} title={title} style={style} />
      <div className={clsx(styles.content, contentClassName)}>{children}</div>
    </div>
  );
};
